import { useTranslate } from "@/utils/lang";
import { Box, Flex, Text, useRadio, useRadioGroup, UseRadioProps } from "@chakra-ui/react";
import { useMemo } from "react";
import { draftStore } from "../store";
import { Editor_Words } from "@/utils/lang/editor";

type RadioCardProps = {
  label: string;
} & UseRadioProps;

const RadioCard = (props: RadioCardProps) => {
  const { label, ...other } = props;
  const { getInputProps, getCheckboxProps } = useRadio(other);

  const input = getInputProps();
  const checkbox = getCheckboxProps();
  const size = useMemo(() => {
    switch (label) {
      case "1:1":
        return { w: "24px", h: "24px" };
      case "3:4":
        return { w: "21px", h: "28px" };
      case "4:3":
        return { w: "28px", h: "21px" };
    }
    throw new Error("unsupported size");
  }, [label]);

  return (
    <Box as="label" mx="8px">
      <input {...input} />
      <Flex
        {...checkbox}
        cursor="pointer"
        align="center"
        _checked={{
          color: "brand.primary",
          borderColor: "brand.primary",
        }}
        _focus={{}}
      >
        <Box w={size.w} h={size.h} borderColor="inherit" borderWidth="1px" borderRadius="2px"></Box>
        <Text
          ml="1em"
          _checked={{
            color: "brand.primary",
          }}
        >
          {label}
        </Text>
      </Flex>
    </Box>
  );
};

export function SizeRadio() {
  const options = ["1:1", "3:4", "4:3"];
  const { translate } = useTranslate();
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "draft-size",
    defaultValue: draftStore.size,
    onChange: draftStore.setSize,
  });

  const group = getRootProps();

  return (
    <Flex mt="16px" align="center">
      <Text fontSize="14px">{translate(Editor_Words["size"])}：</Text>
      <Flex align="center" {...group}>
        {options.map((value) => {
          const radio = getRadioProps({ value });
          return <RadioCard key={value} label={value} {...radio}></RadioCard>;
        })}
      </Flex>
    </Flex>
  );
}
